import { apiClient } from "@nabble/sdk";
import type { AccountEmail } from "./accountEmails";
import type { AccountSession } from "./accountSessions";
import type { Passkey } from "./secondFactors";

export interface AccountInfo {
  /** The primary email: the one used to sign in. */
  email: string;
  /** A change of primary email that waits for the link sent to the new address. */
  pendingEmail: string | null;
  emails: AccountEmail[];
  displayName: string;
  totp: boolean;
  passkeys: Passkey[];
  recoveryCodesRemaining: number;
  sessions: AccountSession[];
}

export function fetchAccount(): Promise<AccountInfo> {
  return apiClient<AccountInfo>("/api/account");
}
